module.exports = __webpack_public_path__ + "static/media/facebook-color.ee94a7ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/facebook-color.svg
// module id = 2404
// module chunks = 0